import l10n from '../lang/locallang';
// eslint-disable-next-line import/no-duplicates
import { findAncestorByTag } from '../helpers';
// eslint-disable-next-line import/no-duplicates
import * as helpers from '../helpers';
import powermailDatepicker from './powermail_datepicker';

const setDate = (datepicker) => {
    if (datepicker.value.length > 0) {
        const dateArray = datepicker.value.split('-');

        const day = document.getElementById('date-day');
        const month = document.getElementById('date-month');
        const year = document.getElementById('date-year');

        day.value = dateArray[2];
        month.value = dateArray[1];
        year.value = dateArray[0];
    }
};

const setSelectYear = (dateSelect) => {
    const select = dateSelect.parentNode.querySelector('select');
    if (!select) {
        return;
    }

    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) {
        return;
    }

    const group = selectedOption.parentNode;
    if (group && group.nodeName === 'OPTGROUP' && group.hasAttribute('label')) {
        dateSelect.setAttribute('value', group.getAttribute('label'));
    }
};

const removeNameAttribute = (name, form, ignoreZero = false) => {
    const field = form.querySelector(`[name="${name}"]`);

    if (field) {
        if ((!ignoreZero && field.value === '0') || field.value === '') {
            field.removeAttribute('name');
        }
    }
};

const checkControllerNameAttribute = (name, form, ...args) => {
    let relatedFields = [];

    if (name === 'tx_news_pi1[search][subject]') {
        relatedFields = relatedFields.concat([
            'tx_news_pi1[__referrer][@request]',
            'tx_news_pi1[__referrer][@extension]',
            'tx_news_pi1[__referrer][@vendor]',
            'tx_news_pi1[__referrer][@controller]',
            'tx_news_pi1[__referrer][@action]',
            'tx_news_pi1[__referrer][arguments]',
            'tx_news_pi1[__trustedProperties]',
        ]);
    }

    if (name === 'tx_news_pi1[overwriteDemand][datecomplete]') {
        relatedFields = relatedFields.concat([
            'tx_news_pi1[overwriteDemand][startFromThisDate]',
        ]);
    }

    if (name === 'tx_stratismap_location[keyword]') {
        relatedFields = relatedFields.concat([
            'tx_stratismap_location[__referrer][@extension]',
            'tx_stratismap_location[__referrer][@vendor]',
            'tx_stratismap_location[__referrer][@controller]',
            'tx_stratismap_location[__referrer][@action]',
            'tx_stratismap_location[__referrer][arguments]',
            'tx_stratismap_location[__referrer][@request]',
            'tx_stratismap_location[__trustedProperties]',
        ]);
    }

    removeNameAttribute(name, form, ...args);

    relatedFields.forEach((relatedField) => {
        removeNameAttribute(relatedField, form, ...args);
    });
};

/**
 * Remove disabled from submit btn
 */
const handleFormFieldChange = (event) => {
    const form = event.target.form;
    if (form) {
        form.querySelector('[type="submit"]').removeAttribute('disabled');
        helpers.removeClass(form.querySelector('[type="submit"]'), '-disabled');
        form.querySelector('.required').remove();

        // eslint-disable-next-line no-use-before-define
        toggleFormFieldsEventListeners(form, false);
    }
};

/**
 * Add event listener for form field
 * @param field - HTMLElement target form field
 * @param eventType - string, 'click' | 'input'
 */
const addFormFieldEventListener = (field, eventType) => {
    field.addEventListener(eventType, handleFormFieldChange);
};

/**
 * Remove event listener for form field
 * @param field - HTMLElement target form field
 * @param eventType - string, 'click' | 'input'
 */
const removeFormFieldEventListener = (field, eventType) => {
    field.removeEventListener(eventType, handleFormFieldChange);
};

/**
 * @param form - HTMLElement, target form
 * @param action - boolean, add or remove listener
 */
const toggleFormFieldsEventListeners = (form, action) => {
    const fieldsWithChangeEvent = [...form.querySelectorAll('input'), ...form.querySelectorAll('textarea'), ...form.querySelectorAll('select')];
    const fieldsWithClickEvent = [...form.querySelectorAll('radio'), ...form.querySelectorAll('checkbox')];

    fieldsWithChangeEvent.forEach((field) => {
        if (action) {
            addFormFieldEventListener(field, 'input');
        } else {
            removeFormFieldEventListener(field, 'input');
        }
    });

    fieldsWithClickEvent.forEach((field) => {
        if (action) {
            addFormFieldEventListener(field, 'click');
        } else {
            removeFormFieldEventListener(field, 'click');
        }
    });
};

export default function formsHandler() {
    const forms = [].slice.call(document.querySelectorAll('form'));

    const resetButtons = [...document.querySelectorAll('button[type="reset"]')];

    resetButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            const form = findAncestorByTag(button, 'form');

            if (form) {
                const selects = [...form.querySelectorAll('select')];
                const multiselect = [...form.querySelectorAll('.multiselect')];
                const submit = form.querySelector('[type="submit"]');
                const radioChecboxElements = [...form.querySelectorAll('input[type="radio"], input[type="checkbox"]')];
                const requiredElements = [...form.querySelectorAll('p.required')];
                const defaultElements = [...form.querySelectorAll('textarea:enabled, input:enabled:not([readonly]), select:enabled')];

                if (submit) {
                    submit.removeAttribute('disabled');
                    helpers.removeClass(submit, '-disabled');
                }

                if (selects.length) {
                    selects.forEach((el) => {
                        const optionSelected = el.querySelector('option[selected]');
                        if (optionSelected) {
                            optionSelected.removeAttribute('selected');
                        }
                    });
                }

                if (radioChecboxElements.length) {
                    radioChecboxElements.forEach((el) => {
                        if (el.indeterminate) el.indeterminate = false;
                        el.removeAttribute('checked');
                        el.checked = false;
                    });
                }

                if (requiredElements.length) {
                    requiredElements.forEach((el) => {
                        el.parentElement.removeChild(el);
                    });
                }

                if (defaultElements.length) {
                    defaultElements.forEach((el) => {
                        el.value = '';
                    });
                }

                if (multiselect.length) {
                    multiselect.forEach((el) => {
                        const toggle = el.querySelector('.multiselect__toggle');
                        toggle.innerHTML = el.getAttribute('data-placeholder');
                    });
                }
            }
        });
    });

    forms.forEach((form) => {
        powermailDatepicker('load', form);
        powermailDatepicker('change', form);

        setTimeout(() => {
            form.addEventListener('submit', (e) => {
                const isValidatorErrorExist = Boolean(document.querySelector('.parsley-error'));
    
                if (isValidatorErrorExist) {
                    return;
                }
    
                const submit = form.querySelector('[type="submit"]');
                const file = form.querySelector('[type="file"]');
                helpers.addClass(submit, '-disabled');
                // submit.setAttribute('disabled', 'true');
    
                if (file && file.value !== '') {
                    submit.insertAdjacentHTML('afterEnd', `<span class="required">${l10n.pleaseWaitForFile}</span>`);
                }
    
                powermailDatepicker('submit', form, e);
    
                const datepicker = document.getElementById('input-date');
    
                if (datepicker !== null) {
                    setDate(datepicker);
                }
    
                toggleFormFieldsEventListeners(form, true);
    
                const dateSelect = document.getElementById('tx_news_year');
    
                if (dateSelect !== null) {
                    setSelectYear(dateSelect);
                }
    
                const agreement = form.querySelector('.js-agreement');
                if (agreement) {
                    const agreementHidden = form.querySelector('#agreement');
                    const agreementItem = [...agreement.querySelectorAll('.agreement-item')];
                    const data = [];
                    agreementItem.forEach((item) => {
                        const selects = [...item.querySelectorAll('select')];
                        const input = item.querySelectorAll('input');
                        const dataItem = {
                            title: input[0].value,
                            tag: selects[0].value,
                            category: selects[1].value,
                        };
                        data.push(dataItem);
                    });
                    agreementHidden.value = JSON.stringify(data);
                }
    
                const fieldsNameToRemove = [
                    { name: 'tx_news_pi1[overwriteDemand][period]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][related]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][categories]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][day]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][month]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][year]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][keywords]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][datecomplete]', ignoreZero: false },
                    { name: 'tx_news_pi1[search][subject]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][tags]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][relatedLinks]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][related]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][relatedLocations]', ignoreZero: false },
                    { name: 'tx_news_pi1[overwriteDemand][relatedAreas]', ignoreZero: false },
                    { name: 'tx_simplepoll_polllisting[category]', ignoreZero: true },
                    { name: 'tx_simplepoll_polllisting[status]', ignoreZero: true },
                    { name: 'tx_stratismap_location[search][keywords]', ignoreZero: false },
                    { name: 'tx_stratismap_location[search][categories][]', ignoreZero: false },
                ];
    
                fieldsNameToRemove.forEach((field) => {
                    checkControllerNameAttribute(field.name, form, field.ignoreZero);
                });
            });
        });
    }, 200);
}
